<template>
  <div class="data-statistics">
    <ServiceChannelStatistics />
    <ArtistMemberStatistics />
    <ServiceMemberConversion />
    <ServiceMemberGrowthTrend />
    <BusinessHandlingStatistics />
    <BusinessGrowthTrend />
  </div>
</template>

<script setup>
import ServiceChannelStatistics from './ServiceChannelStatistics.vue'
import ArtistMemberStatistics from './ArtistMemberStatistics.vue'
import ServiceMemberConversion from './ServiceMemberConversion.vue'
import ServiceMemberGrowthTrend from './ServiceMemberGrowthTrend.vue'
import BusinessHandlingStatistics from './BusinessHandlingStatistics.vue'
import BusinessGrowthTrend from './BusinessGrowthTrend.vue'
</script>

<style lang="scss" scoped>
.data-statistics {
  display: flex;
  box-sizing: border-box;
  width: 100%;
  min-width: 0;
  padding: 4px 0;
  flex-direction: column;
  gap: 16px;
}

@media (max-width: 768px) {
  .data-statistics {
    gap: 14px;
  }
}
</style>
